import React from "react";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import ScroolToUp from "../components/ScrollToTopButton/ScrollToTopButton";
import "./MainLayout.css";
import SEOHelmet from "../components/SEO/SEOHelmet";
import { useLocation } from "react-router-dom";
import AppLocaleProvider from "../context/AppLocalProvider";
import LocaleContextProvider from "../context/LocaleContextProvide";

const MainLayout = ({ children }) => {
  const location = useLocation();

  return (
    <LocaleContextProvider>
      <AppLocaleProvider>
        <div>
          <SEOHelmet page={location.pathname} />
          <Header />
          <main>{children}</main>{" "}
          <ScroolToUp />
          <Footer />
        </div>
      </AppLocaleProvider>
    </LocaleContextProvider>
  );
};

export default React.memo(MainLayout);
